import script from "./customItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./customItem.vue?vue&type=script&setup=true&lang=ts"

import "./customItem.vue?vue&type=style&index=0&id=05140b8c&lang=less"

const __exports__ = script;

export default __exports__